module.exports = __webpack_public_path__ + "6eced3068341caefde8c73afbbda32e1.png";